import { REGEX } from '../const';

export const validateEmail = (email) => {
  if (!email) {
    return { isValid: false, error: 'Please enter your email address' };
  }

  if (!REGEX.EMAIL.test(email)) {
    return { isValid: false, error: 'Please enter a valid email address' };
  }

  // Additional validations
  if (email.length > 255) {
    return { isValid: false, error: 'Email address is too long' };
  }

  if (email.startsWith('.') || email.endsWith('.')) {
    return {
      isValid: false,
      error: 'Email address cannot start or end with a dot',
    };
  }

  if (email.includes('..')) {
    return {
      isValid: false,
      error: 'Email address cannot contain consecutive dots',
    };
  }

  return { isValid: true, error: null };
};

export const validateOtp = (otp) => {
  // Join OTP array if it's an array
  const otpString = Array.isArray(otp) ? otp.join('') : otp;

  if (!otpString) {
    return { isValid: false, error: 'Please enter the OTP' };
  }

  if (otpString.length !== 6) {
    return { isValid: false, error: 'OTP must be 6 digits' };
  }

  // Check if OTP contains only numbers
  if (!/^\d+$/.test(otpString)) {
    return { isValid: false, error: 'OTP must contain only numbers' };
  }

  return { isValid: true, error: null };
};

export const validatePassword = (password, confirmPassword = null) => {
  if (!password) {
    return { isValid: false, error: 'Please enter a password' };
  }

  // Check minimum length
  if (password.length < 8) {
    return {
      isValid: false,
      error: 'Password must be at least 8 characters long',
    };
  }

  // Check for uppercase letter
  if (!/[A-Z]/.test(password)) {
    return {
      isValid: false,
      error: 'Password must contain at least one uppercase letter',
    };
  }

  // Check for lowercase letter
  if (!/[a-z]/.test(password)) {
    return {
      isValid: false,
      error: 'Password must contain at least one lowercase letter',
    };
  }

  // Check for number
  if (!/\d/.test(password)) {
    return {
      isValid: false,
      error: 'Password must contain at least one number',
    };
  }

  // Check for special character
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    return {
      isValid: false,
      error: 'Password must contain at least one special character',
    };
  }

  // If confirmPassword is provided, check if passwords match
  if (confirmPassword !== null && password !== confirmPassword) {
    return {
      isValid: false,
      error: `Those passwords didn't match. Please try again`,
    };
  }

  return { isValid: true, error: null };
};
